import { render, staticRenderFns } from "./FoodDetailView.vue?vue&type=template&id=d0e1bf88&scoped=true"
import script from "./FoodDetailView.vue?vue&type=script&lang=js"
export * from "./FoodDetailView.vue?vue&type=script&lang=js"
import style0 from "./FoodDetailView.vue?vue&type=style&index=0&id=d0e1bf88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0e1bf88",
  null
  
)

export default component.exports